/* eslint-disable import/no-cycle */
import classNames from 'classnames';
import Advantages, { tileIcon } from '$components/Advantages';
import Grid from '$components/layout/Grid';
import { PreloadImage } from '$util/PreloadImage';
import type { PageMeta } from '$util/types';
import { PartOfRenault } from '$quantum/molecules/PartOfRenault';

const { Row, Col } = Grid;

export interface BottomProps {
  readonly pageType?: PageMeta[];
  readonly pageTypeFromPath: string;
}

export function Bottom({ pageType, pageTypeFromPath }: BottomProps): JSX.Element | null {
  const showBottom = ['car', 'car/model', 'area', 'area/car', 'page', 'symptoms'].includes(pageTypeFromPath);
  const showPartOfRenault = ['area', 'area/car', 'page', 'symptoms'].includes(pageTypeFromPath);
  const withPath = ['area', 'area/car', 'page'].includes(pageTypeFromPath);

  if (!showBottom) return null;

  return (
    <Row className={classNames('Bottom')}>
      {pageTypeFromPath === 'symptoms' ? (
        <>
          <PreloadImage provider="cloudinary" src={tileIcon.pin} width={56} />
          <PreloadImage provider="cloudinary" src={tileIcon.wrench} width={56} />
        </>
      ) : (
        <>
          <PreloadImage provider="cloudinary" src={tileIcon.pin} width={56} displayFrom="lg" />
          <PreloadImage provider="cloudinary" src={tileIcon.wrench} width={56} displayFrom="lg" />
        </>
      )}
      <PreloadImage provider="cloudinary" src={tileIcon.quote} width={56} displayFrom="lg" />
      <PreloadImage provider="cloudinary" src={tileIcon.manufacturer} width={56} displayFrom="lg" />
      <Advantages pageType={pageType} pageTypeFromPath={pageTypeFromPath} />
      {showPartOfRenault && (
        <Col span={12} className={classNames('part-of-renault', withPath && 'with-path')}>
          <PartOfRenault preload fromBreakpoint="lg" />
        </Col>
      )}
    </Row>
  );
}
